var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":"刪除代理商","visible":_vm.visible,"confirm-loading":_vm.loading,"maskClosable":false},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('p',[_vm._v("确定要删除这些代理商吗？")])])}
var staticRenderFns = []

export { render, staticRenderFns }